import styles from "./Tooth.module.scss";
import classNames from "classnames";

interface ToothProps {
  tooth: string;
  selected?: boolean;
  color?: string;
  error?: boolean;
  onClick?: () => void;
}

const Tooth = ({ tooth, selected, color, error, onClick }: ToothProps) => {
  return (
    <div
      className={classNames(styles.tooth, {
        [styles.selected]: selected,
        [styles.error]: error,
      })}
      style={color && selected ? { background: color } : undefined}
      onClick={onClick}
    >
      {tooth.slice(4)}
    </div>
  );
};

export default Tooth;
